import styled from 'styled-components';

export const StyledCardBox = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    padding: 20px 24px 23px 20px;
    background-color: #FFFFFF;
    box-shadow: ${({ boxShadow }) => (boxShadow || '0 3px 4px rgba(0, 0, 0, 0.2)')};
    flex: 1;
    min-height: 147px;
  
    .content-header {
      display: flex;
      align-items: center;
      
      img.icon {
        max-width: 25px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
      }
        
      h4 {
        font-family: Poppins-Medium, Heltica, Arial, sans-serif;
        color: #2B2932;
        vertical-align: middle;
        font-size: 13px;
        line-height: 20px;
        margin-bottom: 0;
        display: inline-block;
      }
    }
    
    .content-body {
        font-family: Poppins, Heltica, Arial, sans-serif;
        color: #2E2D37;
        font-size: 16px;
        text-align: left;
        margin: 12px 0 0 0;
        line-height: 25px;
        width: 100%;
        display: flex;
    }
    
    .btn.btn-gearbox {
      font-family: Poppins-Medium, Heltica, Arial, sans-serif;
      width: 100%;
      padding: 11px 0;
      font-size: 12px;
      border-radius: 8px;
      text-align: center;
      background-color: #F3123C;
      border-color: #F3123C;
      color: #FFFFFF;
      outline: none;
      font-weight: bold;
      max-width: 134px;
      max-height: 40px;
      margin-left: 47px;
    }
`;
